module.exports = __webpack_public_path__ + "static/media/search-on.0ef4a462.svg";